module.exports = __webpack_public_path__ + "static/4-7d630448225507071aaa828b4c7db13b.jpg";